/** @format */

import React from 'react';
import {createRoot} from 'react-dom/client';
import CartTotal from './components/cart_total/container';
import Feedback from '../feedback/components/feedback/container';
import SamplePack from '../sample_pack/container';
import DieTemplateGenerator from '../components/die_template/container';

import './css/frontend_legacy.sass';
import {ApplyDesignSystemStyles} from 'frontier/utilities/conditional_design_system';

export default () => {
    const mobileMenuButton = document.querySelector('#mobile_menu_button button');
    if (mobileMenuButton) {
        mobileMenuButton.addEventListener('click', function (e) {
            const button = e.target;
            const dataOpen = button.dataset['open'];
            const isOpen = dataOpen === 'true';

            button.dataset.open = !isOpen;
            button.innerText = isOpen ? 'MENU' : 'CLOSE';
            const mobileOrderButton = document.getElementById('mobile-order-button');

            if (mobileOrderButton) {
                mobileOrderButton.dataset.open = !isOpen;
            }

            const headNav = document.querySelector('.head-nav');

            if (!isOpen) {
                headNav && headNav.classList.remove('closed');
                mobileOrderButton && mobileOrderButton.classList.remove('closed');
            } else {
                headNav && headNav.classList.add('closed');
                mobileOrderButton && mobileOrderButton.classList.add('closed');
            }
        });
    }

    const cartTotalElement = document.getElementById('cart_total');
    if (cartTotalElement) {
        const total = cartTotalElement.dataset['total'];
        const orderCount = cartTotalElement.dataset['order_count'];
        const cartId = cartTotalElement.dataset['cart_id'];
        const userId = cartTotalElement.dataset['user_id'];
        const root = createRoot(cartTotalElement);
        root.render(
            <CartTotal total={total} cartId={cartId} userId={userId} order_count={orderCount} />
        );
    }

    const feedbackElement = document.getElementById('feedback_el');
    if (feedbackElement) {
        const root = createRoot(feedbackElement);
        root.render(<Feedback />);
    }

    // some pages have more than one form
    const samplePackElements = document.querySelectorAll('#sample_pack_el');
    samplePackElements.forEach(samplePackElement => {
        const root = createRoot(samplePackElement);

        root.render(
            <ApplyDesignSystemStyles>
                <SamplePack />
            </ApplyDesignSystemStyles>
        );
    });

    const dieTemplateGeneratorElement = document.getElementById('die_template_generator_el');
    if (dieTemplateGeneratorElement) {
        const root = createRoot(dieTemplateGeneratorElement);
        root.render(<DieTemplateGenerator />);
    }

    setTimeout(() => {
        if (typeof Beacon !== 'undefined') {
            Beacon('once', 'open', function () {
                if (typeof window.dataLayer !== 'undefined') {
                    window.dataLayer.push({
                        event: 'chat_clicked'
                    });
                }
            });
        } else {
            console.log('No Beacon');
        }
    }, 2000);

    // Track the first entry point for this session
    // If the user creates an account during this session, this will be used as the referral
    if (!document.cookie.includes('first_visit_referral=')) {
        let expires = new Date();
        expires.setFullYear(expires.getFullYear() + 1);
        let expiresStr = `; expires=${expires.toUTCString()}; path=/`;

        document.cookie = `first_visit_referral=${encodeURIComponent(
            document.referrer
        )}${expiresStr}`;
        document.cookie = `first_visit_request=${encodeURIComponent(
            window.location.href
        )}${expiresStr}`;
        document.cookie = `first_visit_time=${Math.floor(
            new Date().getTime() / 1000
        )}${expiresStr}`;
    }
};
